/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import { selectProduct } from '../../common/categories/actions';

class Favourite extends React.Component {

    static propTypes = {
        itemNames: React.PropTypes.object,
        itemColors: React.PropTypes.object,
        favouriteItems: React.PropTypes.object,
        frequentlyItemsOffer: React.PropTypes.object,
        offerId: React.PropTypes.number,
        selectProduct: React.PropTypes.func
    };

    render() {
        const {favouriteItems, offerId, itemNames, selectProduct, frequentlyItemsOffer, itemColors} = this.props;

        let maxItem = 10;
        if (favouriteItems && favouriteItems.has(offerId)) {
            maxItem -= favouriteItems.get(offerId).size;
            if (maxItem < 0) {
                maxItem = 0;
            }
        }
        let frequentlyItemsOfferMap = frequentlyItemsOffer;
        if (!!favouriteItems) {
            if (favouriteItems.has(offerId)) {
                frequentlyItemsOfferMap = frequentlyItemsOffer.filter((val, key) => favouriteItems.get(offerId).findIndex(itemId => itemId === key) === -1);
            }
        }

        return (
            <section id="shortcuts" className="favouriteList shortcuts products-grid">
                {!!favouriteItems && favouriteItems.has(offerId)
                && favouriteItems.get(offerId).map((id, index) =>
                  <div className="favouriteList-box" key={`f-item-${index}-${id}`}>
                    <div className={`boxBtn color-white`}>
                        <div className="boxBtn-inner"
                             style={{backgroundColor: itemColors.getIn([id, 'backgroundColor']), color: itemColors.getIn([id, 'textColor'])}}
                             onClick={() => selectProduct(id)}>
                            <span>{itemNames.get(id)}</span>
                        </div>
                    </div>
                  </div>
                )}
                {!!frequentlyItemsOfferMap && frequentlyItemsOfferMap.sortBy((val, key) => val).reverse().slice(0, maxItem).map((val, key) =>
                  <div className="favouriteList-box">
                    <div key={`freq-${key}-homepage`} className="boxBtn color-white">
                        <div className="boxBtn-inner"
                             style={{backgroundColor: itemColors.getIn([key, 'backgroundColor']), color: itemColors.getIn([key, 'textColor'])}}
                             onClick={() => selectProduct(key)}>
                            <span>{itemNames.get(key)}</span>
                        </div>
                    </div>
                  </div>
                )}
            </section>
        );
    }
}


export default connect(state => ({
    favouriteItems: state.favourite.get('favouriteItems'),
    offerId: state.categories.get('offerId'),
    itemNames: state.categories.get('itemNames'),
    itemColors: state.categories.get('itemColors'),
    frequentlyItemsOffer: state.categories.get('frequentlyItemsOffer'),
}), {selectProduct})(Favourite);



// WEBPACK FOOTER //
// ./src/browser/home/Favourite.js